import { Box } from "@mui/material"
import { Steps } from "./Steps"
import { useContext } from "react"
import { ToolContext } from "../../../core/context/ToolContext"
import { Welcome, WelcomeFeature } from "./onBoarding/Welcome"
import { rqx } from "../../../core/request/API"
import { env } from "../../../core/Env"
import Joyride from "react-joyride"

export const Personalization = () => {
    const { personzalition_state, tool_state } = useContext(ToolContext)
    const { welcome , tour} = personzalition_state
    const { userId } = tool_state

    const jrStyle = {
        options:{
            zIndex: 1202,
            width: 250,
            borderRadius:'15px',
        },
        buttonClose: {
            display: 'none'
        },
        buttonNext:{
            fontFamily: "Inter",
            fontWeight: 500,
            backgroundColor: "#0070EF",
            padding: "8px",
            fontSize: "12px !important",
            borderRadius: "15px",
            color: "#fff",
            cursor: "pointer",
            textAlign: "center",
            width: "80px",
            height:'33px'
        },
        buttonSkip:{
            fontFamily: "Inter",
            fontWeight: 500,
            padding: "8px",
            fontSize: "12px !important",
            color: "#A3A3A3",
            cursor: "pointer",
            textAlign: "center",
            width: "80px",
            height:'33px',
            left: 0,
            marginRight:'2px',
            float:'right'
        },
    }

     const handlerSkipGotIt = async (e, type) => {
        if (e.action === 'skip' || e.action === 'reset' || e.action === 'close' || type === 'skip') {
            const body = {
                user_id: userId.data,
                tool_id: process.env.REACT_APP_TID_PSL,
                feature_name: 'welcomepage',
                personalization: [
                    {p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 1}
                ]
            }
            const r = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/create`, body)
            if (r.msg === 'success') {
                welcome.set({start: false, features: false})
                tour.set(false)
            }
            // if (userId.data === 0) {
            //     const d = await getAllData('personalization', 'welcome')
            //     if (d.length !== 0) {
            //         const updated = await updateData('personalization', 'welcome', d[0].id, {
            //             feature_name: 'welcomepage',
            //             personalization: [{p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 1}]
            //         });
            //         if (updated) {
            //             tour.set(false)
            //         }
            //     }
            // }else{
            //     const r = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/create`,
            //         {
            //             user_id: userId.data,
            //             tool_id: process.env.REACT_APP_TID_BIZ,
            //             feature_name: 'welcomepage',
            //             personalization: [
            //                 {p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 1}
            //             ]
            //         })
            //         if (r.msg === 'success') {
            //             tour.set(false)
            //         }
            // }
        }
       
    }
    // useEffect(() => {
    //     const _init = async () => {
    //         const d = await getAllData('personalization', 'welcome')
    //         if (d.length === 0) {
    //             welcome.set((p) => (
    //                 {...p, start : true}
    //             ))
    //         }else{
    //             if (d[0].personalization[1].status === 0) {
    //                welcome.set((p) => (
    //                     {...p, start : false, features: true}
    //                 ))
    //             }
    //         }
    //     };
        
    //     _init()
    //     // eslint-disable-next-line
    // }, [])
    return (
        <Box>
            <Welcome welcome={welcome} userId={userId} tour={tour} />
            <WelcomeFeature welcome={welcome} tour={tour} handlerSkipGotIt={handlerSkipGotIt} /> 
            <Joyride run={tour.data} styles={jrStyle} steps={Steps} continuous={true} locale={{skip: 'Close', last: 'Got it'}}
                disableScrolling hideBackButton={true} spotlightPadding={2} callback={(e) => handlerSkipGotIt(e)}
            />
        </Box>
    )
}
